import React, { useRef } from "react";
import emailjs from "emailjs-com";
import ScrollAnimation from "../components/ScrollAnimation";
import { GET_IN_TOUCH } from "../constants/copy";

export default function GetInTouch() {
  const formRef = useRef();

  const sendMessage = async (e) => {
    e.preventDefault();

    try {
      const formData = new FormData(formRef.current);

      const name = formData.get("name");
      const email = formData.get("email");
      const phone = formData.get("phone");
      const message = formData.get("message");

      // 🔹 SEND EMAIL VIA EMAILJS
      await emailjs.send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        { name, email, phone, message },
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      );

      // 🔹 OPEN WHATSAPP
      const whatsappText = `
New Wedding Enquiry 💍

Name: ${name}
Email: ${email}
Phone: ${phone}

Message:
${message}
      `;

      window.open(
        `https://wa.me/9096846462?text=${encodeURIComponent(whatsappText)}`,
        "_blank"
      );

      alert("Message sent successfully!");
      formRef.current.reset();
    } catch (error) {
      console.error(error);
      alert("Something went wrong. Please try again.");
    }
  };

  return (
    <section className="min-h-[50vh] sm:min-h-[60vh]">
      {/* ================= HERO ================= */}
      <div className="relative w-full h-[38vh] sm:h-[42vh] min-h-[240px] overflow-hidden mb-14">
        <img
          src="https://www.mistay.in/travel-blog/content/images/2020/07/cover-1.jpg"
          alt="Contact Weddmac"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-weddmac-dark/80 via-weddmac-dark/40 to-transparent" />
        <div className="absolute inset-0 flex items-center justify-center">
          <h1 className="font-inria font-light text-4xl md:text-6xl text-white text-center">
            {GET_IN_TOUCH.title}
          </h1>
        </div>
      </div>

      {/* ================= FORM ================= */}
      <div className="max-w-4xl mx-auto px-6 pb-20">
        <p className="section-sub mb-10">{GET_IN_TOUCH.intro}</p>

        <ScrollAnimation>
          <form
            ref={formRef}
            name="contact"
            method="POST"
            data-netlify="true"
            data-netlify-honeypot="bot-field"
            onSubmit={sendMessage}
            className="space-y-5 bg-white/5 border border-white/10 rounded-2xl p-8 shadow-card"
          >
            {/* 🔹 REQUIRED FOR NETLIFY */}
            <input type="hidden" name="form-name" value="contact" />
            <input type="hidden" name="bot-field" />

            <div>
              <label className="form-label">Name</label>
              <input name="name" required className="input-weddmac" />
            </div>

            <div>
              <label className="form-label">Email</label>
              <input type="email" name="email" required className="input-weddmac" />
            </div>

            <div>
              <label className="form-label">Phone</label>
              <input type="tel" name="phone" required className="input-weddmac" />
            </div>

            <div>
              <label className="form-label">Message</label>
              <textarea
                name="message"
                rows="4"
                required
                className="input-weddmac resize-none"
              />
            </div>

            <button type="submit" className="btn-primary w-full">
              Send Message
            </button>
          </form>
        </ScrollAnimation>
      </div>
    </section>
  );
}
